"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractCssVariables = void 0;

/**
 * Represents a CSS variable with its property and value.
 */
// Cache for memoization
var extractCssVariablesCache = new WeakMap();
/**
 * Extracts variables and their values from a CSSStyleSheet.
 * Results are memoized using WeakMap for performance optimization.
 *
 * @param styleSheets - The CSSStyleSheet from which variables are to be extracted.
 * @returns An object representing the extracted variables with their values.
 */

var extractCssVariables = function extractCssVariables(styleSheets) {
  if (!styleSheets) {
    return {};
  } // Check cache first


  var cached = extractCssVariablesCache.get(styleSheets);

  if (cached !== undefined) {
    return cached;
  }

  var result = Object.values(styleSheets.cssRules).reduce(function (brandedConfig, cssRule) {
    if (cssRule instanceof window.CSSStyleRule && cssRule.style) {
      Object.values(cssRule.style).forEach(function (property) {
        if (property && String(property).startsWith('--config')) {
          var propertyName = property.trim();
          var value = cssRule.style.getPropertyValue(propertyName);
          brandedConfig[propertyName] = value;
        }
      });
    }

    return brandedConfig;
  }, {}); // Cache the result

  extractCssVariablesCache.set(styleSheets, result);
  return result;
};
/**
 * Note: WeakMap doesn't provide a way to clear all entries, which is by design
 * since it allows for automatic garbage collection. The cache will be cleared
 * automatically when CSSStyleSheet objects are no longer referenced elsewhere.
 * If you need to force a fresh extraction for a specific stylesheet,
 * ensure that sheet object is recreated rather than reused.
 */


exports.extractCssVariables = extractCssVariables;